import { render, staticRenderFns } from "./block-carousel.vue?vue&type=template&id=f89705e0&scoped=true&"
import script from "./block-carousel.vue?vue&type=script&lang=js&"
export * from "./block-carousel.vue?vue&type=script&lang=js&"
import style0 from "./block-carousel.vue?vue&type=style&index=0&id=f89705e0&lang=scss&scoped=true&"
import style1 from "./block-carousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89705e0",
  null
  
)

export default component.exports